// The signup answers live in this tab only (email, phone, ticket, name,
// password, birthday, guardian) until the account is created.
const KEY = "cache.signup.v2";

export const readSignup = () => {
  try { return JSON.parse(sessionStorage.getItem(KEY) || "{}") || {}; } catch { return {}; }
};

export const writeSignup = (patch) => {
  const next = { ...readSignup(), ...patch };
  try { sessionStorage.setItem(KEY, JSON.stringify(next)); } catch { /* private mode */ }
  return next;
};

export const clearSignup = () => { try { sessionStorage.removeItem(KEY); } catch { /* ignore */ } };
